import React from 'react';

import { observer } from 'mobx-react';

import { salesReportStore } from '../../../../../stores/salesReportStore';
import { FILE_EXTENSION } from '../../../../../../shared/constants/file/FILE_EXTENSIONS';
import { DownloadReportButtons } from '../../../../../components/DownloadReportButtons/DownloadReportButtons';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../../../shared/components/table-components';
import { ReportInfo } from '../../../../../interfaces/ReportInfo';

const { PDF, CSV } = FILE_EXTENSION;

type ReportRowProps = {
  report: ReportInfo;
};

const ReportRow = observer(({ report }: ReportRowProps) => {
  const { openDownloadModal } = salesReportStore;

  return (
    <GridTableRow variant="row" dataTestId="report-row">
      <GridTableCell variant="title">{report.title}</GridTableCell>
      <GridTableCell>{report.description}</GridTableCell>
      <GridTableCell>
        <DownloadReportButtons
          onPdfDownload={() => openDownloadModal(report, PDF)}
          onCsvDownload={() => openDownloadModal(report, CSV)}
        />
      </GridTableCell>
    </GridTableRow>
  );
});

export { ReportRow };
